import { render, staticRenderFns } from "./CompensatoryLeavesListApproved.vue?vue&type=template&id=33e250dd&scoped=true"
import script from "./CompensatoryLeavesListApproved.vue?vue&type=script&lang=js"
export * from "./CompensatoryLeavesListApproved.vue?vue&type=script&lang=js"
import style0 from "./CompensatoryLeavesListApproved.vue?vue&type=style&index=0&id=33e250dd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e250dd",
  null
  
)

export default component.exports